import { render } from "./VideosFilter.vue?vue&type=template&id=515c58e5&ts=true"
import script from "./VideosFilter.vue?vue&type=script&lang=ts"
export * from "./VideosFilter.vue?vue&type=script&lang=ts"

import "./VideosFilter.vue?vue&type=style&index=0&id=515c58e5&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__